import {
  DashboardACD,
  DashboardCaseByUser,
  DashboardUser,
} from "../../../context/dashboard/dashboard";


export const getAlphabetisedDashboardAcdList = (
  dashboardAcdList: DashboardACD[]
): DashboardACD[] => {
  return dashboardAcdList.sort((a: DashboardACD, b: DashboardACD) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );
};

// Needed until dashboard can implement the same user type as TeamQ
export const getAlphabetisedDashboardUserList = (
  userList: DashboardUser[]
): DashboardUser[] =>
  userList.sort((a: DashboardUser, b: DashboardUser) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );

export const getAlphabetisedDashboardCasesByUsersList = (
  casesByUserList: DashboardCaseByUser[]
): DashboardCaseByUser[] =>
  casesByUserList.sort((a: DashboardCaseByUser, b: DashboardCaseByUser) =>
    a.userName.toLowerCase().localeCompare(b.userName.toLowerCase())
  );
